export const getTracesSampleRate = (host, operation) => {
  if (host.includes('test') || host.includes('staging')) return 1.0
  if (operation == 'pageload') return 0.1
  return 0.0
}
